import { render, staticRenderFns } from "./CommunityFeeTypeTree.vue?vue&type=template&id=f07a709a&scoped=true"
import script from "./CommunityFeeTypeTree.vue?vue&type=script&lang=js"
export * from "./CommunityFeeTypeTree.vue?vue&type=script&lang=js"
import style0 from "./CommunityFeeTypeTree.vue?vue&type=style&index=0&id=f07a709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07a709a",
  null
  
)

export default component.exports